import { useMutation } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

const mutation = gql`
  mutation jobSignOffApprove($cloudId: String!) {
    jobSignOffApprove(input: { cloudId: $cloudId }) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/jobSignOffApprove').type;

export type JobSignOffApproveVariables = OperationVariables<typeof mutation>;
export type JobSignOffApproveResult = OperationData<typeof mutation>;

export const useJobSignOffApprove = () => {
  const tuple = useMutation(mutation);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) => {
      return _mutate({
        context: { service: 'core' },
        refetchQueries: [
          'GetJob',
          'GetJobComments',
          'GetNotificationCountForUser',
        ],
        awaitRefetchQueries: true,
        update(cache) {
          cache.evict({ fieldName: 'getJobSignOffs' });
        },
        ...options,
      });
    },
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
